import { tv } from 'tailwind-variants';

// Outer FlipCards layout slots (parent grid + footnote)
export const defaultVariants = tv({
  slots: {
    base: ['flex', 'flex-col', 'gap-4'],
    footNote: ['rte **:font-medium md:**:font-light **:leading-5.25'],
  },
});

// Per-tile slots for the 3D flip card surface
export const flipCardVariants = tv({
  slots: {
    scene: ['group', 'relative', 'w-full', 'h-full', 'min-h-80'],
    card: [
      'relative w-full h-full',
      'focus-visible:outline-none focus-visible:[box-shadow:0_0_0_0.2rem_rgba(38,143,255,0.5)] focus-visible:border-[#0062cc]',
    ],
    interactive: ['min-[769px]:group-hover:transform-[rotateY(180deg)]'],
    face: ['flex flex-col', 'p-6', 'overflow-hidden', 'transform-gpu'],
    bgImage: ['object-cover'],
    bgOverlay: ['absolute inset-0 bg-black/50 pointer-events-none'],
    content: ['flipCardRte relative z-1 flex-1 block content-center'],
    flipIcon: [
      'absolute bottom-3 right-3 z-2',
      'inline-flex items-center justify-center',
      'w-4 h-4',
      'text-base leading-none font-normal text-white',
      'cursor-pointer',
      'focus-visible:outline-none focus-visible:[box-shadow:0_0_0_0.2rem_rgba(38,143,255,0.5)]',
    ],
    srOnly: ['sr-only'],
  },
  variants: {
    isFlippable: {
      true: {
        card: ['min-h-70', 'transition-transform duration-300 ease-linear', 'transform-3d'],
        face: ['absolute', 'inset-0', 'backface-hidden', 'transform-gpu'],
        content: [
          'overflow-y-auto min-h-0',
          '[scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        ],
      },
      false: {
        face: ['relative', 'w-full', 'h-full'],
      },
    },
    isFlipped: {
      true: { card: ['transform-[rotateY(180deg)]'] },
      false: { card: [] },
    },
    isVisible: {
      true: { face: ['pointer-events-auto'] },
      false: { face: ['pointer-events-none'] },
    },
    isBack: {
      true: { face: ['transform-[rotateY(180deg)_translateZ(1px)]'] },
      false: { face: ['transform-[translateZ(1px)]'] },
    },
  },
  compoundVariants: [
    {
      isFlippable: true,
      isBack: true,
      class: { face: 'min-[769px]:group-hover:pointer-events-auto' },
    },
    {
      isFlippable: true,
      isBack: false,
      class: { face: 'min-[769px]:group-hover:pointer-events-none' },
    },
  ],
  defaultVariants: { isFlippable: true, isFlipped: false, isVisible: true, isBack: false },
});
